/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Scorecard_SuffixInputs */

const en_directory_detail_scorecard_suffix = /** @type {(inputs: Directory_Detail_Scorecard_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Tool Scorecard`)
};

const zh_directory_detail_scorecard_suffix = /** @type {(inputs: Directory_Detail_Scorecard_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 工具评分卡`)
};

/**
* | output |
* | --- |
* | "AI Tool Scorecard" |
*
* @param {Directory_Detail_Scorecard_SuffixInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_scorecard_suffix = /** @type {((inputs?: Directory_Detail_Scorecard_SuffixInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Scorecard_SuffixInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_scorecard_suffix(inputs)
	return zh_directory_detail_scorecard_suffix(inputs)
});
export { directory_detail_scorecard_suffix as "directory.detail.scorecard_suffix" }